const admin = {
  context: {
    api_id: "5697645",
    viewer_type: "4",
    ads_app_id: "5697645_2b001c426565a25c90",
    api_url: "https://api.vk.com/api.php",
    ad_info: "ElsdCQdURlRtAwZNRARQBHR8FAsmMQxVUUZGNgBQbwYfQyQrWQA"
  },
  email: {
    confirm: false,
    verification: "5xywrisx0ruzsyjmmwmnhezzq",
    address: "vaaituganov@gmail.com"
  },
  id: "id6871962",
  fullName: 'Виктория Михайлова',
  paymentInfoId: "AVkw1cO085PWecGvCftA",
  tokenTransport: "8f9afd2b-f95a-40ff-8dcf-fa3a3d59f983",
  tokenVK: "7cf0820355e6ad11fc75fe95de4cc57fd9e7015b762e1ced1dbab7ff0fd26665ed3ccc8748b87158cffc5",
  tsConfirm: 1483533731857,
}

const buyoutDates = {
  delivery: new Date(),
  distribution: new Date(),
  purchasing: new Date(),
  stop: new Date()
}

const paymentInfos = [{
  active: true,
  deleted: false,
  id: "AVkw1cO085PWecGvCftA",
  note: "Сбербанк. Примечание при переводе оставлять пустым!",
  title: "Test from profile",
  titleForShow: "4576 8902 3456 7890 (Сбербанк. Примечание при переводе оставлять пустым!)",
  tsCreated: 1482583032731,
  type: "card",
  userId: "id6871962",
  value: "4576 8902 3456 7890"
}, {
  active: true,
  deleted: false,
  id: "AVkw1cO085PWecGvCftA1",
  note: "Альфа банк. Примечание при переводе оставлять пустым!",
  title: "Test from profile",
  titleForShow: "4576 6900 3456 4521 (Альфа банк. Примечание при переводе оставлять пустым!)",
  tsCreated: 1482583032731,
  type: "card",
  userId: "id6871962",
  value: "4576 6900 3456 4521"
}]

const pickupPoints = [{
  "active": true,
  "address": "Дружбы 42/2",
  "note": "Центральный офис, с 8 до 17",
  "shortTitle": "ДЖБ",
  "title": "Дружба",
  "sourceId": -95161863,
  "id": "AVszkk2QEUGxjKGd6ZoM"
}, {
  "active": true,
  "address": "КМ 111",
  "note": "Уже не работает",
  "shortTitle": "Старый",
  "title": "Карла Маркса",
  "sourceId": -95161863,
  "id": "AVs8tkXONkP2_rDRU_Fb"
}, {
  "active": true,
  "address": "Суворова 56/1",
  "note": "Пн-Пт 08:00-17:00, СБ 08:00-13:00, ВС выходной",
  "shortTitle": "",
  "title": "Суворова",
  "sourceId": -95161863,
  "id": "AVszovmNNkP2_rDRU9Qj"
}]

const buyoutFirst = {
  adminId: "id6871962",
  admin: admin,
  albumIds: ["-95161863_227638497"],
  albums: [{
    preview: 'https://cs7052.userapi.com/c636331/v636331512/3992d/bLgOQ12jDAA.jpg'
  }],
  amounts: {users: {6871962: {sum: 2710, payed: 2710}}, own: {sum: 2710, payed: 2710}},
  currency: 'RUB',
  buyoutCurrency: 'RUB',
  dates: buyoutDates,
  fee: 10,
  id: "demo_gepur",
  isDemo: true,
  paymentInfos: paymentInfos,
  pickupPoints: pickupPoints,
  priceChange: {active: true, percent: 10, value: 5},
  priceRound: {type: "five", active: true},
  sourceId: -95161863,
  payed: true,
  status: "closed",
  paymentStatus: 'payed',
  template: {appLink: true, describeOrders: true, greeting: true, orgInfo: true, textAfterMess: "Заказ необходимо оплатить в ближайшее время. !!!"},
  title: "Гепюр",
  tsCreated: 1483958870339
}

const buyoutSecond = {
  adminId: "id6871962",
  admin: admin,
  albumIds: ["-95161863_227638497"],
  albums: [{
    preview: 'https://pp.userapi.com/c626330/v626330512/12d89/XEU8QYAGC3c.jpg'
  }],
  amounts: {users: {6871962: {sum: 145, payed: 0}}, own: {sum: 145, payed: 0}},
  currency: 'RUB',
  buyoutCurrency: 'RUB',
  dates: buyoutDates,
  fee: 10,
  id: "demo_sima",
  isDemo: true,
  paymentInfos: paymentInfos,
  pickupPoints: pickupPoints,
  priceChange: {active: true, percent: 10, value: 5},
  priceRound: {type: "five", active: true},
  sourceId: -95161863,
  payed: false,
  status: "purchasing",
  paymentStatus: 'needConfirm',
  template: {appLink: true, describeOrders: true, greeting: true, orgInfo: true, textAfterMess: "Заказ необходимо оплатить в ближайшее время. !!!"},
  title: "Сима лэнд",
  tsCreated: 1483958870339
}

const buyoutItemFirst = {
  buyoutId: buyoutFirst.id,
  pickupPointCustomer: pickupPoints[0],
  orderNumber: 'ААА 001',
  invoices: [{
    status: "payed",
    "amount": 2710.0,
    ordersCnt: 2,
    invalid: false,
    trackBy: "6871962.dr9K7l8jtbWTUJa3sqzfyR",
    id: "AVuuRAUaLlqTYg9Zt9Da"
  }],
  orders: {
    size: 2,
    photos: {
      '-95161863_398575391': {
        preview: "https://pp.userapi.com/c636018/v636018962/3e810/6tIBlsj6Cvs.jpg",
        id: "-95161863_398575391",
        url: "https://vk.com/photo-134681298_456239020"
      },
      '-95161863_398575398': {
        preview: "https://pp.userapi.com/c636018/v636018962/3e818/jXFcM_7emcg.jpg",
        id: "-95161863_398575398",
        url: "https://vk.com/photo-134681298_456239021"
      }
    },
    items: [{
      albumId: "-95161863_227638497",
      buyoutId: "AVmC12FH85PWecGvCfzm",
      commentId: 148,
      count: 1,
      fee: 1,
      feeValue: 14.93,
      id: "AVmC2tw9O3S7vfumVyI4",
      ownerId: 6871962,
      payed: false,
      photoId: "-95161863_398575391",
      price: 1493,
      size: "44",
      color: "Лазурный",
      title: "Платье с перфорацией",
      total: 1510,
      totalWithFee: 1510,
      totalWithoutFee: 1493,
      tsCreated: 1483959098429
    }, {
      albumId: "-95161863_227638497",
      buyoutId: "AVmC12FH85PWecGvCfzm",
      commentId: 148,
      count: 1,
      fee: 1,
      feeValue: 14.93,
      id: "AVmC2tw9O3S7vfumVyI4a",
      ownerId: 6871962,
      payed: false,
      photoId: "-95161863_398575398",
      price: 1493,
      size: "44",
      color: "Роскошный",
      title: "Роскошное женственное платье",
      total: 1200,
      totalWithFee: 1200,
      totalWithoutFee: 1200,
      tsCreated: 1483959098429
    }]
  },
  payment: {
    buyoutId: "demo_gepur",
    isDemo: true,
    confirmation: {
      date: new Date(),
      text: "Здесь будет текст подтверждения оплаты от клиента"
    },
    id: "AVmC57ihO3S7vfumVyJA",
    ownerId: 6871962,
    status: "payed",
    tsCreated: 1483959941277
  }
}

const buyoutItemSecond = {
  orderNumber: 'ААА 002',
  buyoutId: buyoutSecond.id,
  invoices: [{
    status: "needConfirm",
    amount: 145.00,
    ordersCnt: 2,
    invalid: false,
    trackBy: "6871962.dr9K7l8jtbWTUJa3sqzfyR",
    id: "AVuuRAUaLlqTYg9Zt9Da"
  }],
  orders: {
    size: 2,
    photos: {
      '-95161863_398575391': {
        preview: "https://pp.userapi.com/c636018/v636018962/3e81f/VH_sy9bxY2k.jpg",
        id: "-95161863_398575391",
        url: "https://vk.com/photo-134681298_456239022"
      },
      '-95161863_398575398': {
        preview: "https://pp.userapi.com/c636018/v636018962/3e826/XVYcu7I6_Ns.jpg",
        id: "-95161863_398575398",
        url: "https://vk.com/photo-134681298_456239023"
      }
    },
    items: [{
      albumId: "-95161863_227638497",
      buyoutId: "AVmC12FH85PWecGvCfzm",
      commentId: 148,
      count: 1,
      fee: 1,
      feeValue: 14.93,
      id: "AVmC2tw9O3S7vfumVyI4",
      ownerId: 6871962,
      payed: false,
      photoId: "-95161863_398575391",
      price: 120,
      title: 'Игрушка-антистресс на присоске "На удачу" 11см',
      total: 120,
      totalWithFee: 120,
      totalWithoutFee: 120,
      tsCreated: 1483959098429
    }, {
      albumId: "-95161863_227638497",
      buyoutId: "AVmC12FH85PWecGvCfzm",
      commentId: 148,
      count: 1,
      fee: 1,
      feeValue: 14.93,
      id: "AVmC2tw9O3S7vfumVyI4a",
      ownerId: 6871962,
      payed: false,
      photoId: "-95161863_398575398",
      price: 25,
      title: 'Ёлка-открытка с мишурой "С Новым годом!" (зверята)',
      total: 25,
      totalWithFee: 25,
      totalWithoutFee: 25,
      tsCreated: 1483959098429
    }]
  },
  payment: {
    buyoutId: "demo_sima",
    isDemo: true,
    confirmation: {
      amount: 145,
      date: new Date(),
      text: "Здесь будет текст подтверждения оплаты от клиента"
    },
    id: "AVmC57ihO3S7vfumVyJA",
    ownerId: 6871962,
    status: "needConfirm",
    tsCreated: 1483959941277
  }
}

function getBalance () {
  return {
    owner: {
      id: 95161863,
      url: "https://vk.com/sp_pom",
      preview: "https://pp.userapi.com/c836320/v836320934/65e1a/78Ld-pShYA0.jpg",
      balanceType: "group",
      title: "СП помощник",
      ownerId: -95161863,
      isMessagesAllowed: true,
      hasMessagesPermissions: false,
      adminLevel: 3
    },
    balance: 450.0
  }
}

function getBuyouts (isArchive) {
  return {
    items: isArchive ? [] : [buyoutFirst, buyoutSecond],
    size: isArchive ? 0 : 2
  };
}

function getBuyout (id) {
  return id === buyoutFirst.id ? buyoutFirst : buyoutSecond;
}

function getBuyoutItem (buyoutId) {
  return buyoutId === buyoutFirst.id ? buyoutItemFirst : buyoutItemSecond;
}

function getComments () {
  return {
    size: 2,
    items: [{
      aid: 240277003,
      date: 1482470872000,
      id: 137,
      ownerId: 6871962,
      pid: 456239077,
      status: "fresh",
      text: "Здесь ваш клиент сможет увидеть комментарии, которые он оставлял в групе"
    }, {
      aid: 240277003,
      date: 1482470872000,
      id: 138,
      ownerId: 6871962,
      pid: 456239077,
      status: "fresh",
      text: "Да да, абсолютно все! :-)"
    }]
  };
}

function getTransactions () {
  return {
    size: 2,
    customer: {
      url: 'https://vk.com/sp_pom',
      title: 'СП Помощник',
      photo: 'https://pp.userapi.com/c636018/v636018962/3e874/0jauDWYGFSA.jpg'
    },
    items: [{
      ownerId: 9591512,
      customerId: 6871962,
      amount: 1000.0,
      tsCreated: 1488195251601,
      status: "done",
      note: "Возврат за непришедшие товары",
      id: "AVp_WW2RO3S7vfumWmBG"
    },
      {
        ownerId: 9591512,
        customerId: 6871962,
        amount: -550.0,
        tsCreated: 1489860466906,
        status: "done",
        note: "Оплата покупок с баланса",
        id: "AVrimpjaO3S7vfumXN_t"
      }
    ],
    owner: {
      ownerId: 9591512,
      firstName: "Виктория",
      lastName: "Михайлова",
      domain: "test",
      photo: "./assets/images/mock_avatar.jpg",
      fullName: "Виктория Михайлова",
      id: 9591512
    }
  };
}

export {
  getBalance,
  getBuyouts,
  getBuyout,
  getBuyoutItem,
  getComments,
  getTransactions
};